<route>
{
  "meta": {
    "permission": [
      "expenses.view_expense"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <v-row row wrap>
      <v-col cols="12" sm="3">
        <i-date-picker
          v-model="start"
          :label="$tc('start_date')"
          color="primary"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <i-date-picker
          v-model="end"
          :label="$t('end_date')"
          color="primary"
          :min="start"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="account"
          :name="$t('account')"
          v-slot="{ errors }"
        >
          <v-select
            autocomplete="off"
            outlined
            :error-messages="errors[0]"
            v-model="form.account"
            item-text="name"
            item-value="pk"
            :items="accounts"
            :label="$t('account')"
          ></v-select>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="category"
          :name="$tc('category', 1)"
          v-slot="{ errors }"
        >
          <v-select
            autocomplete="off"
            outlined
            :error-messages="errors[0]"
            v-model="form.category"
            item-text="name"
            item-value="pk"
            :items="categories"
            :label="$tc('category', 1)"
          ></v-select>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="expense_type"
          :name="$t('expense_type')"
          v-slot="{ errors }"
        >
          <v-select
            autocomplete="off"
            outlined
            :error-messages="errors[0]"
            v-model="form.recurring"
            item-text="name"
            item-value="pk"
            :items="expense_type"
            :label="$t('expense_type')"
          ></v-select>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn color="secondary" @click="clear()">
          {{ $t('clear') }}
        </v-btn>
      </v-col>
    </v-row>
    <i-table
      :title="$tc('expense', 2)"
      :headers="headers"
      app="expenses.expense"
      api="expense"
      :opt="{
        date_from: this.start,
        date_to: this.end,
        account: this.form.account,
        category: this.form.category,
        recurring: this.form.recurring
      }"
      show-expand
      :expanded.sync="expanded"
      single-expand
      dontCreate
      dontRemove
      dontEdit
      dontSearch
    >
      <template v-slot:item.data-table-expand="{ isExpanded, expand, item }">
        <v-btn
          v-if="item.recurrent"
          icon
          @click="expand(!isExpanded)"
          :color="isExpanded ? 'primary' : ''"
        >
          <v-icon>{{
            isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
          }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.start_date="{ item }">
        <span
          v-text="item.start_date != null ? dateFormat(item.start_date) : ''"
        ></span>
      </template>
      <template v-slot:item.recurrent="{ item }">
        <span v-text="item.recurrent ? $t('yes') : $t('No')"></span>
      </template>
      <template v-slot:item.cost="{ item }">
        <i-money :value="item.cost" mode="text"></i-money>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-4 blue-grey lighten-5">
          <h4 class="mb-2">{{ $t('paymentsHistory') }}</h4>
          <v-simple-table dense class="elevation-1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">{{ $t('date') }}</th>
                  <th class="text-left">{{ $t('description') }}</th>
                  <th class="text-left">{{ $t('operator') }}</th>
                  <th class="text-left">{{ $t('cost') }}</th>
                  <th class="text-left">{{ $t('reference') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in item.payments" :key="p.pk">
                  <td>{{ dateFormat(p.start_date) }}</td>
                  <td>{{ p.description }}</td>
                  <td>{{ p.operator }}</td>
                  <td><i-money :value="p.cost" mode="text"></i-money></td>
                  <td>{{ p.reference }}</td>
                </tr>
                <tr v-if="!item.payments || item.payments.length === 0">
                  <td colspan="5" class="text-center italic grey--text">
                    {{ $t('noPaymentRecords') }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
      <template v-slot:extraToolbar>
        <v-divider class="mx-4" inset vertical></v-divider>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-excel"
          :title="$t('download', { value: $tc('expense', 2) })"
          color="text-dark"
          @click="getExpensesExcel()"
        >
        </i-btn>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-pdf"
          :title="$t('download', { value: $tc('expense', 2) })"
          color="text-dark"
          @click="getExpensesPDF()"
        >
        </i-btn>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      modalBD: false,
      modalBD2: false,
      start: '',
      end: '',
      form: {
        date_from: '',
        date_to: '',
        account: '',
        category: '',
        recurring: null
      },
      accounts: [],
      categories: [],
      expense_type: [
        { pk: null, name: this.$t('all') },
        { pk: false, name: this.$t('expenses_regular') },
        { pk: true, name: this.$t('expenses_recurring') }
      ],
      expanded: []
    }
  },
  mounted() {
    this.getAccounts()
    this.getCategories()
  },
  computed: {
    headers() {
      return [
        {
          text: this.$tc('category', 1),
          value: 'category.name'
        },
        {
          text: this.$t('account'),
          value: 'account.name'
        },
        {
          text: this.$t('date'),
          value: 'start_date'
        },
        {
          text: this.$t('operator'),
          value: 'operator'
        },
        {
          text: this.$t('description'),
          value: 'description'
        },
        {
          text: this.$tc('recurrent', 0),
          value: 'recurrent'
        },
        {
          text: this.$tc('cost', 1),
          value: 'cost',
          align: 'right'
        },
        {
          text: this.$t('reference'),
          value: 'reference'
        }
      ]
    },
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    getExpensesExcel() {
      this.downloadFile({
        api: 'expense',
        method: 'excel',
        filename: 'Expenses',
        action: 'download',
        ext: 'xlsx',
        opt: {
          pk: this.company.pk,
          params:
            '?account=' +
            this.form.account +
            '&date_from=' +
            this.start +
            '&date_to=' +
            this.end +
            '&category=' +
            this.form.category +
            '&recurring=' +
            this.form.recurring
        }
      })
    },
    getExpensesPDF() {
      this.downloadFile({
        api: 'expense',
        method: 'pdf',
        filename: 'Expenses',
        action: 'download',
        ext: 'pdf',
        opt: {
          pk: this.company.pk,
          params:
            '?account=' +
            this.form.account +
            '&date_from=' +
            this.start +
            '&date_to=' +
            this.end +
            '&category=' +
            this.form.category +
            '&recurring=' +
            this.form.recurring
        }
      })
    },
    getAccounts() {
      this.$api.expense.account.list({}).then((response) => {
        this.accounts = response.data.results
      })
    },
    getCategories() {
      this.$api.expense.category.list({}).then((response) => {
        this.categories = response.data.results
      })
    },
    clear() {
      this.form = {
        date_from: '',
        date_to: '',
        account: '',
        category: '',
        recurring: null
      }
      this.start = ''
      this.end = ''
    }
  },
  watch: {
    start: {
      handler(val) {
        if (val) {
          this.form.date_from = this.dateFormat(val)
        }
      }
    },
    end: {
      handler(val) {
        if (val) {
          this.form.date_to = this.dateFormat(val)
        }
      }
    }
  }
}
</script>
